<template lang="pug">
  div.map-popup
    div
      div.tooltip__head
        p.title {{head}}
        span(@click="close($event)").close.close--small.close--tooltip
      div.tooltip__body
        div(v-if="!head")
          p неверный формат данных, нужно:
          code(
          style="overflow:scroll;height:100px;"
          ) {{getExample()}}
          p получено:
          code(
          style="overflow:scroll;height:100px;"
          ) {{fields}}
        popup-fields-rows(
        v-else
        :rows="rows"
        :model="fields"
        )
      div.tooltip__foot
        button(v-if="showMore" @click.prevent="more") Подробнее
</template>

<script>
  import baseMapPopupMixin from './base-map-popup-mixin.js'
  import PopupFieldsRows from './popup-fields-rows.vue'

  export default {
    components: {PopupFieldsRows},
    mixins: [baseMapPopupMixin],
    name: 'map-popup',
    data () {
      this.closeCallback = null
      this.redirectParams = {}
    },
    created() {
      // для этого (popup-offline) типа всплывашки . закрываем ссылку Подробнее ...
      this.showMore = false;
    },
    methods: {
      getExample () {
        return {
          head: '',
          fields: {},
          rows: {}
        }
      },
      injectConf (options) {
        let {model = {}, closeCallback, redirectParams = null} = options
        this.closeCallback = closeCallback
        if (model.fields) {
          this.rows = Object.assign({}, model.fields)
        }
        if (model.head) {
          this.head = model.head
        }
        if (model.model) {
          this.fields = Object.assign({}, model.model)
        } else {
          this.fields = Object.assign({}, model)
        }
        if (redirectParams) {
          this.redirectParams = redirectParams
        }
        this.registerVueInMap()
      },
      close ($event) {
        this.closeCallback($event)
      },
      registerClosePopup () {}
    }
  }
</script>
